<template>
  <div class="app  " style="background-color: black;
      margin: 0;
      padding: 0;
      font-family: 'Lato', sans-serif;
      overflow: hidden;
      background: black;
      -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
">
    <div class="bg">
      <div class="bg-img" v-bind:src="bgImage"></div>
    </div>
    <div class="container scroll-auto ">
      <img src="images/bg.jpg" alt="Background Cache" class="img-cache">

      <div class="login-container" key="loginPanel">
        <b-alert variant="warning"
                 :show="browserMsg.length > 0"
                 @dismissed="showDismissibleAlert=false">
          {{ browserMsg }}
        </b-alert>
        <div class="login" ref="login">
          <transition name="left" key="left" appear>
            <div no-body class="login-left" v-on:keyup.enter="login" v-if="showLogin" ref="loginLeft">
              <div style="text-align:right; padding:20px;">
                <a class="field-link" href="https://www.marketscan.com/Support" title="Get Online Support">
                  <font-awesome-icon icon="headset" size="lg" />
                </a>
              </div>
              <div class="login-content">
                <div class="header">Sign In</div>

                <div class="username field">
                  <div class="field-label">Account</div>
                  <input name="Account number" v-validate="{required: true, min: 1, max: 40}" v-model.trim="loginInfo.account" type="text" class="field-input" />
                  <div class="field-underline">
                    <div class="field-underline-bar"></div>
                  </div>
                </div>
                <div class="username field">
                  <div class="field-label">Username</div>
                  <input name="Username" v-validate="{required: true, min: 1, max: 40}" v-model.trim="loginInfo.login" type="text" class="field-input" />
                  <div class="field-underline">
                    <div class="field-underline-bar"></div>
                  </div>
                </div>
                <div class="password field">
                  <div class="field-label">Password</div>
                  <input name="Password" v-validate="{required: true, min: 1, max: 40}" v-model.trim="loginInfo.password" type="password" class="field-input" />
                  <div class="field-underline">
                    <div class="field-underline-bar"></div>
                  </div>
                </div>
                <a @click="showForgotPasswordDialog()" class="field-link">Forgot password</a>
                <div style="display:block; text-align:center"><a @click="login" class="login-btn" style="display:block">Login</a></div>

                <div  style="display:block; text-align:center">
                  <strong class="login-error">{{errMsg}}</strong>
                  <div class="login-error"  v-for="err in validateErrors.items" :key="err.id">
                    <p><strong class="login-error">{{ err.msg }}</strong></p>
                  </div>
                </div>

              </div>

            </div>
          </transition>
          <transition name="right" key="right">
            <div class="login-right" ref="loginRight">
              <div class="bg-logo-rows"></div>
              <img src="../assets/mportal-logo.png" alt="mPortal Logo" class="mportal-logo">
            </div>
          </transition>
        </div>
        <div class="mt-4" v-if="forgotPassword.emailSent && forgotPassword.isValid">
          <span class="pull-right" style="font-style: italic">Password reset information was sent to {{forgotPassword.email}}.</span>
        </div>

      </div>

    </div>
    <b-modal id="modal1" ref="forgotPasswordDialog" @shown="focusEmail">
      <template v-slot:modal-header>
        <div class="modal-cust-header">
          Forgot your password?

        </div>
      </template>
      <div class="modal-inner">
        <strong v-if="!forgotPassword.isValid" class="login-error">A valid email and account are required.</strong>

        <label class="modal-field-label">Account</label>
        <input class="modal-field" type="text" ref="forgotPasswordAccountRef" placeholder="Account#" v-model="loginInfo.account" @keyup.enter.native="forgotPasswordClick()" />

        <label class="modal-field-label">Email</label>
        <input class="modal-field" type="text" ref="forgotPasswordEmailRef" placeholder="Email" v-model="forgotPassword.email" @keyup.enter.native="forgotPasswordClick()" @keydown.native="forgotPasswordEmailChanged" />

      </div>
      <template v-slot:modal-footer>
        <button @click="hideForgotPasswordDialog()" class="modal-login-btn">Cancel</button>

        <button v-if="!forgotPassword.sending" class="modal-login-btn modal-login-btn-submit"
                :disabled="!forgotPassword.isValid"
                @click="forgotPasswordClick()">
          Reset Password
        </button>
        <button v-else :disabled="true" class="modal-login-btn modal-login-btn-submit">
          Reset Password
        </button>

      </template>
    </b-modal>
    <loading :show="boolLoading"
             :label="txtLoading">
    </loading>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import loading from 'vue-full-loading'
import Router from '@/router'
import Store from '@/store'
import VueCookies from 'vue-cookies'
import tokenexpiration from '@/shared/tokenexpiration'

import VeeValidate from 'vee-validate'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeadset } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// add login css
import '@/assets/scss/login.css?ver=2.0'
import '@/assets/scss/login-mobile.css'
import '@/assets/scss/modal.css'
library.add(faHeadset)
Vue.component('font-awesome-icon', FontAwesomeIcon)
// import '@/auth/login.js'

const config = {
  aria: true,
  classNames: {},
  classes: false,
  delay: 0,
  dictionary: null,
  errorBagName: 'validateErrors', // change if property conflicts
  events: 'input|blur',
  fieldsBagName: 'validateFields',
  i18n: null, // the vue-i18n plugin instance
  i18nRootKey: 'validations', // the nested key under which the validation messages will be located
  inject: true,
  locale: 'en',
  strict: true,
  validity: false
}

Vue.use(VeeValidate, config)

Vue.use(VueCookies)

export default {
  name: 'login',
  components: {
    loading
  },
  created () {
    if (tokenexpiration.checkCookieExpiredInLogin(this)) {
      this.errMsg = 'Sorry, your session has timed out because of inactivity. Please sign in again.'
      this.showDismissibleAlert = true
      this.dismissibleType = 'warning'
    }

    if (this.$cookies.isKey('dpCookieAccount')) {
      if (this.$cookies.get('dpCookieAccount').length > 0) { this.loginInfo.account = this.$cookies.get('dpCookieAccount') }
    }

    var ua = window.navigator.userAgent
    // IE 11
    var trident = ua.indexOf('Trident/')
    if (trident > 0) {
      var rv = ua.indexOf('rv:')
      if (rv > 0) {
        // var ie11 = parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
        this.browserMsg = 'You may have a better experience with another browser like Chrome or Firefox.'
      }
    }

    // var introTl = new TimelineMax(),
    //  loginCollapsed = false,
    //  isMobile = false,
    //  introAnimationDone = false,
    //  introProps = {
    //      bg: {
    //        duration: 1.5
    //      },
    //      login: {
    //        resize: {
    //          duration: 0.75
    //        }
    //      }
    //    }
  },
  mounted () {
    if (window.innerWidth < 1041) {
      this.$refs.login.removeChild(this.$refs.loginLeft)
      this.$refs.login.appendChild(this.$refs.loginLeft)
    }
    if (this.$route.query.account) {
      this.loginInfo.account = this.$route.query.account
    }
  },
  updated () {
    if (mobilecheck()) {
      this.bgImage = "'../mobile-bg.jpg'"
    } else {
      // $(".container").mousemove(function (e) {
      //  parallaxIt(e, ".bg", -30);
      // });
      this.bgImage = "'../bg.jpg'"
    }
  },
  data () {
    return {
      browserMsg: '',
      errMsg: '',
      dismissibleType: 'danger',
      showDismissibleAlert: false,
      boolLoading: false,
      txtLoading: 'Loading...',
      loginInfo: {
        account: '',
        login: '',
        password: ''
      },
      bgImage: ' ../bg.jpg',
      showLogin: true,
      forgotPassword: {
        emailSent: false,
        sending: false,
        isValid: true,
        email: ''
      }
    }
  },
  beforeCreate () {
    if (this.$cookies.isKey('.jwt') && !Store.state.passwordChangeRequired) {
      Router.push('/')
    }
  },
  methods: {

    login () {
      var self = this

      self.$validator.validateAll().then(async (result) => {
        if (result) {
          self.boolLoading = true
          var error = await self.$loginUser(this.loginInfo)

          self.boolLoading = false

          if (error) {
            try {
              var code = parseInt(error.response.status)

              if (code === 401 || code === 403 || (code >= 500 && code < 600)) {
                self.errMsg = ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
              } else {
                self.errMsg = '(' + error.response.status + ') ' +
                    ((error !== undefined && error.response !== undefined && error.response.statusText !== undefined) ? error.response.statusText : error)
              }
            } catch (e) { self.errMsg = error.message }

            self.showDismissibleAlert = true
          } else {
            if (Store.state.passwordChangeRequired) {
              Router.push('/MyProfile/1')
            }
            else {
              if (localStorage.getItem("externalRunScanParams") != undefined || localStorage.getItem("externalRunScanParams") != null) {
                var externalScanParams = JSON.parse(localStorage.getItem("externalRunScanParams"));
                localStorage.setItem("PendingScanParam", "true");
                console.log(externalScanParams)
                if (externalScanParams != null && externalScanParams !== undefined && externalScanParams.templateid !== undefined && externalScanParams.app === undefined) {
                  this.$router.push('/mGauge/VehicleSampling')
                }
                if (externalScanParams != null && externalScanParams !== undefined && externalScanParams.templateid !== undefined && externalScanParams.app === 'mscope') {
                  this.$router.push('/mScope/VehicleSampling')
                }
              }
              Router.push(this.$route.query.redirect || '/')
            }
          }
        }
      })
    },

    // Password reset

    /* func */
    forgotPasswordValidate () {
      if (this.forgotPassword.email === '' || this.loginInfo.account === '') {
        this.forgotPassword.isValid = false
        return
      }
      this.forgotPassword.isValid = true
    },

    forgotPasswordClick () {
      this.forgotPasswordValidate()
      if (!this.forgotPassword.isValid) { return }
      this.sendForgotPasswordRequest()
    },

    showForgotPasswordDialog () { this.$refs.forgotPasswordDialog.show() },

    hideForgotPasswordDialog () { this.$refs.forgotPasswordDialog.hide() },

    /* ajax */
    sendForgotPasswordRequest () {
      var self = this
      this.forgotPassword.sending = true
      this.forgotPassword.isValid = true
      axios.post('/auth/forgotpassword', { 'email': this.forgotPassword.email, 'account': this.loginInfo.account })
        .then(response => {
          self.forgotPassword.sending = false
          self.forgotPassword.emailSent = true
          self.hideForgotPasswordDialog()
        })
        .catch(error => {
          self.forgotPassword.sending = false
          self.forgotPassword.emailSent = false
        })
    },

    /* Evt */
    forgotPasswordEmailChanged (e) {
      if (e.key !== 'enter') {
        this.forgotPasswordValidate()
        this.forgotPassword.emailSent = false
      }
    },

    focusEmail (e) {
      if (this.loginInfo.account === '') {
        this.$refs.forgotPasswordAccountRef.focus()
        return
      }
      this.$refs.forgotPasswordEmailRef.focus()
    },

    mobilecheck () {
      if (screen.width <= 1041) {
        return true
      } else {
        return false
      }
    }
  }
}
</script>
<style scoped>
  .container {
    width: 100%;
    height: auto;
    min-height: 100vh;
    position: relative;
    float: left;
}
</style>



// WEBPACK FOOTER //
// src/auth/Login.vue